"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Quest = void 0;
const definables_1 = require("definables");
const NPC_1 = require("./NPC");
class Quest extends definables_1.Definable {
    constructor(options) {
        super(options.id);
        this._availableText = options.definition.availableText;
        this._completedText = options.definition.completedText;
        this._experience = options.definition.experience;
        this._gold = options.definition.gold;
        this._inProgressText = options.definition.inProgressText;
        this._monster =
            typeof options.definition.monster !== "undefined"
                ? {
                    kills: options.definition.monster.kills,
                    monsterID: options.definition.monster.monsterID,
                }
                : undefined;
        this._name = options.definition.name;
        this._npcID = options.definition.npcID;
        this._prerequisiteQuestID = options.definition.prerequisiteQuestID;
    }
    get availableText() {
        return this._availableText;
    }
    get completedText() {
        return this._completedText;
    }
    get experience() {
        return this._experience;
    }
    get gold() {
        return this._gold;
    }
    get inProgressText() {
        return this._inProgressText;
    }
    get monster() {
        if (typeof this._monster !== "undefined") {
            return this._monster;
        }
        throw new Error("Quest does not have a monster");
    }
    get name() {
        return this._name;
    }
    get npcID() {
        return this._npcID;
    }
    get npc() {
        return (0, definables_1.getDefinable)(NPC_1.NPC, this._npcID);
    }
    get prerequisiteQuestID() {
        if (typeof this._prerequisiteQuestID !== "undefined") {
            return this._prerequisiteQuestID;
        }
        throw new Error(this.getAccessorErrorMessage("prerequisiteQuestID"));
    }
    hasMonster() {
        return typeof this._monster !== "undefined";
    }
    hasPrerequisiteQuest() {
        return typeof this._prerequisiteQuestID !== "undefined";
    }
}
exports.Quest = Quest;
